import React from "react";
import { rgbToHex } from "shared/helpers/ColorsHelper";

const ProgressBar = (props) => {
  const { bgcolorPrimary, bgcolorSecondary, completed } = props;
  const primaryColor = rgbToHex(bgcolorPrimary);
  const secondaryColor = rgbToHex(bgcolorSecondary);
  const completedDisplay = Math.min(completed, 100);

  const fillerStylesLeft = {
    height: "100%",
    width: `${completedDisplay}%`,
    background: `linear-gradient(to left, ${primaryColor}, ${secondaryColor})`,
    borderRadius: "0",
    textAlign: "center",
    transition: "width 1s ease-in-out",
    fontSize: "14px",
    fontWeight: "bold",
  };

  const fillerStylesFull = {
    ...fillerStylesLeft,
    borderRadius: "20px",
  };

  const labelStylesWhite = {
    color: "white",
  };

  const labelStylesBlack = {
    ...labelStylesWhite,
    color: "#606060",
    marginLeft: "100%",
    paddingLeft: "5px",
  };

  const small = completedDisplay < 20;

  return (
    <div className="progress-bar-container">
      <div style={small ? fillerStylesLeft : fillerStylesFull}>
        <span
          style={
            small ? labelStylesBlack : labelStylesWhite
          }>{`${completedDisplay}%`}</span>
      </div>
    </div>
  );
};

export default ProgressBar;
